(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JoinVideoMeetingEventComponentController', JoinVideoMeetingEventComponentController);

    function JoinVideoMeetingEventComponentController($scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, $window, $mdDialog) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.joinMeetingURL = "";
        $ctrl.entity = entity;
        // $ctrl.orderBagItem = {};
        $ctrl.moderatorName = "";
        $ctrl.createMeeting = createMeeting;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.goToMeetingRoom = goToMeetingRoom;

        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.serviceItem = entity.serviceItem;

            if (entity.servant && entity.servant.personInfo.fullName) {
                $ctrl.servant = entity.servant;
                $ctrl.moderatorName = entity.servant.personInfo.fullName;
            }
        }

        function createMeeting() {

            getVideoMeetingUrl();
        }


        function getVideoMeetingUrl() {
            var newMeeting = {};

            newMeeting.serviceItemId = $ctrl.serviceItem.id;
            newMeeting.servantId = $ctrl.servant.id;
            newMeeting.mode = 'event';
            newMeeting.password = $ctrl.serviceItem.servantMeetingPassword;
            newMeeting.fullName = $ctrl.moderatorName;


            OrderBagServiceItemCustom.createVideoMeetingEvent().save(newMeeting, onCreateMeetingSuccess, onCreateMeetingFailed);

            function onCreateMeetingSuccess(result) {


                if (result.joinMeetingURL) {
                    $ctrl.joinMeetingURL = result.joinMeetingURL;
                    $ctrl.successMsg = "createSuccess";
                    $ctrl.errorMsg = "";
                }

            }

            function onCreateMeetingFailed() {
                $ctrl.joinMeetingURL = "";
                $ctrl.successMsg = "";
                $ctrl.errorMsg = "createError";
            }


        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }

        function goToMeetingRoom() {
            $window.open($ctrl.joinMeetingURL, "_blank");
            $mdDialog.hide();
        }


    }

    var JoinVideoMeetingEventComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
        controller: JoinVideoMeetingEventComponentController,
        bindings:
            {
                serviceItem: '=',
                serviceItemId: '=',
                servant: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfJoinVideoMeetingEvent', JoinVideoMeetingEventComponent)

    JoinVideoMeetingEventComponentController.$inject = ['$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', '$window', '$mdDialog'];


})();

